import client from './client';

/**
 * Городские объекты 2ГИС: ориентиры, площадки, парковки, проходы, посёлки.
 *
 * Ручки ПУБЛИЧНЫЕ (`/api/v1/city-objects`) — те же, что читает приложение.
 * Так админка показывает ровно то, что видит житель, а не свою копию правды;
 * тот же приём уже используется у `DistrictSelect` (`GET /api/v1/districts`).
 */

export interface CityDataset {
  key: string;
  title: string;
  count: number;
  subtypes: Record<string, number>;
}

export interface CityObject {
  id: number;
  name: string | null;
  subtype: string | null;
  address: string | null;
  district_id: number | null;
  lat: number | null;
  lon: number | null;
  has_polygon: boolean;
  distance_m: number | null;
}

export interface CityObjectFeature {
  type: 'Feature';
  geometry: { type: string; coordinates: any } | null;
  properties: {
    id: number;
    name: string | null;
    subtype: string | null;
    address: string | null;
    district_id: number | null;
    dataset: string;
  };
}

export const cityObjectsApi = {
  datasets: () =>
    client.get<CityDataset[]>('/api/v1/city-objects/datasets').then((r) => r.data),

  list: (dataset: string, subtype?: string, limit = 2000) =>
    client
      .get<{ dataset: string; items: CityObject[]; returned: number }>(
        '/api/v1/city-objects',
        { params: { dataset, subtype, limit } }
      )
      .then((r) => r.data),

  geojson: (dataset: string, subtype?: string) =>
    client
      .get<{ type: 'FeatureCollection'; features: CityObjectFeature[] }>(
        '/api/v1/city-objects/geojson',
        { params: { dataset, subtype } }
      )
      .then((r) => r.data),
};
